import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ContactUsButtonCard from "./contact-us-button-card";
import { Grid } from "@mui/material";
import { getDataFromCmsApi } from "../../api/contentful-service";
import { getRandomColors } from "../../utils/utils";

const ContactUsGrid = ({ buttonCardsComponent }) => {
    const [phoneDirectory, setPhoneDirectory] = useState({});

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const divisionContact = await getDataFromCmsApi("DivisionContact/IsGroup");

        const phoneNumbersMap = {};
        divisionContact?.forEach((curr) => {
            if (!curr?.divisionAbbreviations?.includes("TXC")) {
                curr?.phoneNumbers?.forEach((phone) => {
                    const [name, number] = phone.split(":");
                    if (name && number) {
                        phoneNumbersMap[name.trim()] = number.trim();
                    }
                });
            } else {
                phoneNumbersMap["Tax Collector & Tax Sale"] = curr?.phoneNumbers[0];
            }
        });

        const sortedPhoneNumbersMap = Object.fromEntries(
            Object.entries(phoneNumbersMap).sort((a, b) => a[0].localeCompare(b[0]))
        );
        setPhoneDirectory(sortedPhoneNumbersMap);
    };

    const cardColors = getRandomColors(buttonCardsComponent?.length || 0, buttonCardsComponent?.name || "");

    return (
        // modify Grid container's width and margin-left to account for its top-left padding from the spacing={4} (32px spacing) */}
        <Grid
            container
            spacing={4}
            minHeight={700}
            width="calc(100% + 32px)"
            margin="-32px 0 0 -32px !important"
        >
            {buttonCardsComponent?.map((item, index) => (
                <Grid item key={index} xs={12} lg={6}>
                    <ContactUsButtonCard
                        phoneDirectory={phoneDirectory}
                        cardColor={cardColors[index % cardColors.length]}
                        cardData={item}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

ContactUsGrid.propTypes = {
    buttonCardsComponent: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ContactUsGrid;
